import { toValue } from 'vue'
import { defineStore } from 'pinia'
import Update from '@/classes/updates/Update'
import Updates from '@/classes/updates/Updates'
import { pick as _pick } from 'lodash'

export const useUpdateStore = defineStore('UpdateStore', {
  state: () => ({
    updates: {},
    update: {},
    loader: false,
    error: {}
  }),
  getters: {
    getUpdates: state => ({ query } = {}) => state.$getItems({
      resource: 'updates',
      query,
      fetch: () => state.fetchUpdates({ query })
    }),
    getUpdate: state => ({ id }) => state.$getItem({
      resource: 'update',
      key: id,
      fetch: () => state.fetchUpdate({ id })
    })
  },
  actions: {
    fetchUpdates ({ query }) {
      return this.$fetchItems({
        endpoint: '/api/v1/updates',
        resource: 'updates',
        model: Updates,
        query
      })
    },
    async fetchUpdate ({ id }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$fetchItem({
        endpoint: `/api/v1/updates/${toValue(id)}`,
        resource: `update.${toValue(id)}`,
        model: Update
      })
    },
    postUpdate ({ params }) {
      return this.$postItem({
        endpoint: '/api/v1/updates',
        resource: 'update.{id}',
        model: Update,
        params: {
          update: new Update(params)
        }
      })
    },
    async patchUpdate ({ params, id }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$patchItem({
        endpoint: `/api/v1/updates/${toValue(id)}`,
        resource: `update.${toValue(id)}`,
        model: Update,
        params: {
          update: _pick(new Update(params), Object.keys(params))
        }
      })
    },
    async deleteUpdate ({ id }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$deleteItem({
        endpoint: `/api/v1/updates/${toValue(id)}`,
        resource: toValue(id)
      })
    }
  }
})